export const environment = {
  production: true,
  apiHost: 'https://ubnqiqygz8.execute-api.us-east-1.amazonaws.com/prod',
  region: "us-east-1",
  userPoolId: 'us-east-1_6ricT1Kvj',
  userPoolWebClientId: '6d0eq38i62m9eeo3869cckrmn3',
  authenticationFlowType: 'USER_PASSWORD_AUTH'
};
